/* Sob Cart — storefront behaviour */
(function () {
  'use strict';

  /* ---------- gallery ---------- */
  var main = document.getElementById('PdpMain');
  if (main) {
    document.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.getAttribute('data-thumb');
        document.querySelectorAll('[data-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- variants ---------- */
  var form = document.getElementById('PdpForm');
  var json = document.querySelector('[data-product-json]');
  if (form && json) {
    var variants = [];
    try { variants = JSON.parse(json.textContent); } catch (e) { variants = []; }

    var idField = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var atc = form.querySelector('[data-atc]');
    var atcText = form.querySelector('[data-atc-text]');

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function selection() {
      return Array.prototype.map.call(
        form.querySelectorAll('[data-option-index]'),
        function (group) {
          var on = group.querySelector('[aria-checked="true"]');
          return on ? on.getAttribute('data-opt-value') : null;
        }
      );
    }

    function match(sel) {
      return variants.find(function (v) {
        return sel.every(function (val, i) {
          return val === null || v.options[i] === val;
        });
      });
    }

    function refresh() {
      var sel = selection();
      var v = match(sel);

      /* grey out combinations that do not exist */
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('[data-opt-value]').forEach(function (btn) {
          var probe = sel.slice();
          probe[idx] = btn.getAttribute('data-opt-value');
          var found = variants.find(function (vr) {
            return probe.every(function (val, i) {
              return val === null || vr.options[i] === val;
            });
          });
          var ok = !!(found && found.available);
          if (btn.classList.contains('size')) {
            btn.disabled = !ok;
          } else {
            btn.style.opacity = ok ? '' : '.35';
          }
        });
      });

      if (!v) return;

      if (idField) idField.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (atc) atc.disabled = !v.available;
      if (atcText) atcText.textContent = v.available ? 'Add to cart' : 'Sold out';

      if (v.featured_image && main) main.src = v.featured_image.src;

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    form.querySelectorAll('[data-opt-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-option-index]');
        group.querySelectorAll('[data-opt-value]').forEach(function (b) {
          b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
        });
        var label = group.querySelector('[data-option-label]');
        if (label) label.textContent = btn.getAttribute('data-opt-value');
        refresh();
      });
    });

    refresh();
  }

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }
})();
